import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";

/** Diálogo de cadastro/edição de curso. */
export default function CursoForm({ curso, onClose, onSave, isSaving }) {
  const [descricao, setDescricao] = useState("");
  const [abreviacao, setAbreviacao] = useState("");

  useEffect(() => {
    if (!curso) return;
    setDescricao(curso.descricao ?? "");
    setAbreviacao(curso.abreviacao ?? "");
  }, [curso]);

  const podeSalvar = descricao.trim() !== "" && !isSaving;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!podeSalvar) return;
    onSave({ ...curso, descricao: descricao.trim(), abreviacao: abreviacao.trim() });
  };

  return (
    <Dialog open={Boolean(curso)} onClose={onClose} fullWidth maxWidth="xs">
      <form onSubmit={handleSubmit}>
        <DialogTitle>{curso?.codCurso ? "Editar Curso" : "Novo Curso"}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} pt={1}>
            <TextField
              size="small"
              fullWidth
              required
              autoFocus
              label="Descrição"
              value={descricao}
              onChange={(event) => setDescricao(event.target.value)}
              helperText={`${descricao.length}/45`}
              slotProps={{ htmlInput: { maxLength: 45 } }}
            />
            <TextField
              size="small"
              fullWidth
              label="Abreviação"
              value={abreviacao}
              onChange={(event) => setAbreviacao(event.target.value)}
              helperText="Até 4 caracteres."
              slotProps={{ htmlInput: { maxLength: 4 } }}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained" disabled={!podeSalvar}>
            Salvar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
